<template>
  <div class="container pdf_document">
    <div class="header">
      <div class="icon_list pointer">
        <div class="icon">
          <el-image :src="editor"></el-image>
        </div>
        <div class="menu">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <el-image :src="menu"></el-image>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="openFile">打开文件</el-dropdown-item>
              <el-dropdown-item command="save">保存</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div @click="chooseFile">
          <SvgComponent icon-name="file" />
        </div>
        <div class="bar">
          <div
            @click="chooseBar(index)"
            v-for="(item, index) in pdfBar"
            :key="item"
            :class="index === pafBarNum ? 'bar_active' : ''"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>

    <!-- 初始加载状态 -->
    <div v-if="isInitialLoading" class="loading-overlay">
      <div class="loading-content">
        <i class="el-icon-loading loading-icon"></i>
        <span class="loading-text">加载中...</span>
      </div>
    </div>

    <div v-else-if="isEmpty" class="empty">
      <el-image :src="empty" fit="fit" size="20"></el-image>
      <span>请选择PDF文件</span>
    </div>
    <div class="pdf_container" v-else>
      <div></div>
      <div class="pdf_pages_wrapper">
        <div
          class="pdf_page_item"
          v-for="(page, index) in canvasContainer"
          :key="index"
        >
          <canvas
            :ref="`canvasRef_${index}`"
            class="pdf_canvas"
            @contextmenu.prevent="handRightClick(index, $event)"
          ></canvas>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
import icon from "../assets/icon.png";
import editor from "../assets/editor.png";
import menu from "../assets/meun.svg";
import empty from "../assets/empty.svg";
import SvgComponent from "../components/SvgComponent";
import { choosePDF, PDFController, swapItems } from "../utilis";
import { degrees, PDFDocument } from "pdf-lib";

export default {
  name: "Document",
  components: { SvgComponent },
  data() {
    return {
      icon,
      editor,
      menu,
      empty,
      name,
      originalInfo: null,
      pdfBar: ["文件", "编辑", "注释", "打印"],
      pafBarNum: 0,
      pdfShowNum: 0,
      canvasContainer: [],
      pdfDocument: null,
      currentScale: 1.0,
      renderTasks: [],
      isInitialLoading: false,
      resizeTimer: null,
      menuList: ["向上移动", "向下移动", "裁剪页面", "旋转页面"],
      handMenuNum: null,
      loadingInstance: null,
      isCropMode: false,
      cropArea: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        isSelecting: false,
        originalData: "",
        canvas: null,
      },
      canvasFunc: {
        isCrop: {},
        notCrop: {},
      },
    };
  },

  computed: {
    isEmpty: function () {
      return this.canvasContainer.length === 0 && !this.isInitialLoading;
    },
  },

  methods: {
    handleCommand(command) {
      switch (command) {
        case "openFile":
          this.chooseFile();
          break;
        case "save":
          this.save();
          break;
      }
    },

    // 选择文件
    async chooseFile() {
      try {
        const fileItems = await choosePDF();
        // 检查是否选择了文件
        if (!fileItems || fileItems.length === 0) {
          console.log("用户取消了选择");
          return;
        }

        // 获取第一个文件（单选情况下）
        const firstFile = fileItems[0]; // ✅ 获取数组的第一个元素
        const { file, name } = firstFile; // ✅ 现在可以解构了
        this.name = name;
        const pdfInfo = new PDFController();

        // 显示加载中
        this.showLoading();
        this.originalInfo = await file.arrayBuffer();
        console.log(this.originalInfo);
        this.pdfDocument = await pdfInfo.readFile(file);
        const pageNums = await this.pdfDocument.numPages;

        // 清空之前的页面
        this.canvasContainer = [];

        // 存储页面对象
        for (let num = 1; num <= pageNums; num++) {
          const page = await this.pdfDocument.getPage(num);
          this.canvasContainer.push({
            page,
            rotate: 0,
          });
        }

        // 等待DOM更新
        await this.$nextTick();

        // 渲染所有页面
        await this.renderAllPages();
      } catch (error) {
        console.error("加载PDF失败:", error);
        this.hideLoading();
        this.$message.error("文件加载失败，请重试");
      }
    },

    // 渲染所有页面
    async renderAllPages() {
      if (!this.canvasContainer.length || !this.pdfDocument) return;

      // 清空之前的渲染任务
      this.renderTasks = [];

      // 获取容器的参考宽度（使用第二个div作为参考）
      const container = document.querySelector(".pdf_pages_wrapper");
      if (!container) return;

      const containerWidth = container.clientWidth;

      // 为每个页面创建渲染任务
      for (let i = 0; i < this.canvasContainer.length; i++) {
        this.renderTasks.push(this.renderPage(i, containerWidth));
      }

      // 并行渲染所有页面
      const results = await Promise.allSettled(this.renderTasks);

      // 检查结果
      const failed = results.filter((result) => result.status === "rejected");

      if (failed.length > 0) {
        console.error(`${failed.length}个页面渲染失败`);
        this.$message.error(`${failed.length}个页面加载失败，请重新尝试`);
      }
    },

    // 渲染单个页面
    async renderPage(index, containerWidth, option) {
      try {
        const page = this.canvasContainer[index].page;

        // 获取canvas元素
        const canvas = this.$refs[`canvasRef_${index}`][0];
        if (!canvas) {
          console.error(`Canvas ${index} 未找到`);
          return;
        }

        // 如果当前页面正在裁剪模式，先退出裁剪模式
        if (index === this.pdfShowNum && this.isCropMode) {
          this.exitCropMode();
        }

        // 获取页面原始尺寸
        const viewport = page.getViewport({ scale: 1 });
        const pageWidth = viewport.width;

        // 计算缩放比例（使页面宽度适应容器）
        const scale = (containerWidth - 40) / pageWidth; // 减去一些边距
        this.currentScale = scale;

        // 获取缩放后的viewport
        const rotation = option ? option.currentRotation : 0;
        const scaledViewport = page.getViewport({ scale, rotation });

        // 获取设备像素比（解决清晰度问题）
        const dpr = window.devicePixelRatio || 1;

        // 设置Canvas实际像素尺寸
        canvas.width = Math.floor(scaledViewport.width * dpr);
        canvas.height = Math.floor(scaledViewport.height * dpr);

        // 设置Canvas显示尺寸
        canvas.style.width = `${scaledViewport.width}px`;
        canvas.style.height = `${scaledViewport.height}px`;

        // 获取2D上下文
        const ctx = canvas.getContext("2d");

        // 缩放上下文以匹配高DPI
        ctx.scale(dpr, dpr);

        // 清除画布
        ctx.clearRect(0, 0, scaledViewport.width, scaledViewport.height);

        const renderContext = {
          canvasContext: ctx,
          viewport: scaledViewport,
        };

        await page.render(renderContext).promise;

        if (index === this.canvasContainer.length - 1) {
          this.hideLoading();
        }

        console.log(`页面 ${index + 1} 渲染完成，缩放: ${scale}`);
      } catch (error) {
        console.error(`渲染页面 ${index + 1} 失败:`, error);
      }
    },

    handleResize() {
      if (this.canvasContainer.length > 0) {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          // 如果处于裁剪模式，先退出
          if (this.isCropMode) {
            this.exitCropMode();
            this.$message.info("页面缩放已退出裁剪模式");
          }
          this.renderAllPages();
        }, 200);
      }
    },

    // 显示加载状态（使用Element UI的Loading）
    showLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close();
      }
      this.loadingInstance = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },

    // 隐藏加载状态
    hideLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close();
        this.loadingInstance = null;
      }
    },

    // 页面初始化方法
    async initializePage() {
      this.isInitialLoading = true;

      setTimeout(() => {
        this.isInitialLoading = false;
      }, 1500);
    },

    // 拦截鼠标点击右键的方法
    handRightClick(index, event) {
      this.pdfShowNum = index;
      const pointY = event.clientY;
      if (pointY > 60) {
        event.preventDefault();
        this.exitCropMode();
        this.showMenu(event.clientX, event.clientY);
      }
      return;
    },

    // 创建功能菜单
    createMenu() {
      const menu = document.createElement("div");
      menu.className = "menu_list";
      const menuList = this.menuList;
      menu.style.display = "none";
      menuList.forEach((e, index) => {
        const item = document.createElement("div");
        item.style.padding = "8px 16px";
        item.style.cursor = "pointer";
        item.style.whiteSpace = "nowrap";
        item.style.color = "#333";
        item.style.fontSize = "14px";
        item.onclick = () => {
          this.handleMenuClick(e, index);
        };
        // 鼠标悬停效果
        item.onmouseenter = function () {
          this.style.backgroundColor = "#f5f5f5";
        };
        item.onmouseleave = function () {
          this.style.backgroundColor = "transparent";
        };
        item.innerHTML = e;
        menu.appendChild(item);
      });

      const parent = document.querySelector(".container ");
      parent.appendChild(menu);
    },

    // 展示功能菜单
    showMenu(x, y) {
      const menu = document.querySelector(".menu_list");
      menu.style.display = "flex";
      menu.style.backgroundColor = "#ffffff";
      menu.style.flexDirection = "column";
      menu.style.boxShadow = "0 0 14px 3px hsla(0, 0%, 59%, .45)";
      menu.style.position = "fixed";
      menu.style.zIndex = "1000";
      menu.style.top = y + "px";
      menu.style.left = x + "px";
    },

    // 隐藏功能菜单
    hideMenu() {
      const menu = document.querySelector(".menu_list");
      menu.style.display = "none";
    },

    // 全局处理，隐藏功能菜单
    handleGlobalClick(event) {
      const menu = document.querySelector(".menu_list");

      // 如果菜单不存在或不可见，不处理
      if (!menu || menu.style.display === "none") {
        return;
      }

      // 检查点击是否在菜单内
      if (!menu.contains(event.target)) {
        // 点击的是菜单外部，隐藏菜单
        this.hideMenu();
      }
    },

    chooseBar(index) {
      this.pafBarNum = index;
      if (index === 3) {
        this.print();
      }
    },

    print() {
      // TODO 完善打印页面布局
    },

    // 处理功能菜单
    async handleMenuClick(e, index) {
      if (index === 0) {
        await this.moveUp();
      }

      if (index === 1) {
        await this.moveDown();
      }

      if (index === 2) {
        await this.splitPage();
      }

      if (index === 3) {
        await this.ratePage();
      }

      this.hideMenu();
    },

    // 处理页面向上移动逻辑
    async moveUp() {
      try {
        if (this.pdfShowNum === 0) {
          this.$message.error(`当前页为首页`);
          return;
        }
        this.canvasContainer = swapItems(
          this.canvasContainer,
          this.pdfShowNum - 1,
          this.pdfShowNum
        );

        await this.renderAllPages();

        this.$message.success("页面已完成调整");
      } catch (e) {
        console.error("页面交换出错");
      }
    },

    // 处理页面向下移动逻辑
    async moveDown() {
      try {
        if (this.pdfShowNum === this.canvasContainer.length - 1) {
          this.$message.error(`当前页为尾页`);
          return;
        }
        this.canvasContainer = swapItems(
          this.canvasContainer,
          this.pdfShowNum,
          this.pdfShowNum + 1
        );

        await this.renderAllPages();

        this.$message.success("页面已完成调整");
      } catch (e) {
        console.error("页面交换出错");
      }
    },

    // 处理剪裁页面
    async splitPage() {
      await this.showOverly();
    },

    async showOverly() {
      if (this.isCropMode) {
        this.$message.info("正处于剪切模式中");
        return;
      }
      this.isCropMode = true;
      await this.showCropOverlayOnCanvas();
    },

    // 在Canvas上显示裁剪遮罩层
    async showCropOverlayOnCanvas() {
      const canvas = this.$refs[`canvasRef_${this.pdfShowNum}`][0];
      if (!canvas) return;

      // 获取Canvas上下文
      const ctx = canvas.getContext("2d");

      // 先保存当前Canvas状态
      const originalData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      this.cropArea.originalData = originalData;
      this.cropArea.canvas = canvas;
      this.cropArea.ctx = ctx;

      // 绘制半透明黑色遮罩层
      ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绑定事件监听
      canvas.addEventListener("mousedown", this.handleCropMouseDown);
      canvas.addEventListener("mousemove", this.handleCropMouseMove);
      canvas.addEventListener("mouseup", this.handleCropMouseUp);
    },

    // 鼠标按下事件
    handleCropMouseDown(event) {
      if (!this.isCropMode) return;

      console.log("🖱️ 开始拖动选择框...");

      const canvas = this.cropArea.canvas;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      // 计算Canvas上的坐标
      const x = (event.clientX - rect.left) * dpr;
      const y = (event.clientY - rect.top) * dpr;

      this.cropArea.isSelecting = true;
      this.cropArea.startX = x;
      this.cropArea.startY = y;
      this.cropArea.currentX = x;
      this.cropArea.currentY = y;

      console.log("起始坐标设置:", { startX: x, startY: y });

      // 立即绘制选择框
      this.drawCropSelection();
    },

    // 鼠标移动事件
    handleCropMouseMove(event) {
      if (!this.isCropMode || !this.cropArea.isSelecting) return;

      const canvas = this.cropArea.canvas;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      // 直接计算并更新坐标，不做距离判断
      const newX = (event.clientX - rect.left) * dpr;
      const newY = (event.clientY - rect.top) * dpr;

      // 更新坐标
      this.cropArea.currentX = newX;
      this.cropArea.currentY = newY;

      console.log("🔄 鼠标移动 - 更新坐标:", {
        clientX: event.clientX,
        clientY: event.clientY,
        rect: { left: rect.left, top: rect.top },
        newX,
        newY,
        diffX: Math.abs(newX - this.cropArea.startX),
        diffY: Math.abs(newY - this.cropArea.startY),
      });

      this.drawCropSelection();
    },

    // 鼠标抬起事件
    handleCropMouseUp(event) {
      if (!this.isCropMode || !this.cropArea.isSelecting) return;

      console.log("🖱️ 鼠标抬起 - 结束拖动");

      const canvas = this.cropArea.canvas;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      // 更新最终坐标
      this.cropArea.currentX = (event.clientX - rect.left) * dpr;
      this.cropArea.currentY = (event.clientY - rect.top) * dpr;
      this.cropArea.isSelecting = false;

      // 计算最终尺寸
      const cssWidth =
        Math.abs(this.cropArea.currentX - this.cropArea.startX) / dpr;
      const cssHeight =
        Math.abs(this.cropArea.currentY - this.cropArea.startY) / dpr;

      console.log("✅ 拖动完成 - 最终结果:", {
        startX: this.cropArea.startX,
        startY: this.cropArea.startY,
        currentX: this.cropArea.currentX,
        currentY: this.cropArea.currentY,
        cssWidth,
        cssHeight,
        isValid: cssWidth > 10 && cssHeight > 10,
      });

      this.drawCropSelection();
    },

    // 绘制选择框
    drawCropSelection() {
      const { canvas, ctx, originalData, startX, startY, currentX, currentY } =
        this.cropArea;
      const dpr = window.devicePixelRatio || 1;

      // 1. 恢复原始图像
      ctx.putImageData(originalData, 0, 0);

      // 2. 重新绘制遮罩层
      ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 3. 绘制选择框（清除选择框内的遮罩层）
      const x = Math.min(startX, currentX) / dpr;
      const y = Math.min(startY, currentY) / dpr;
      const width = Math.abs(currentX - startX) / dpr;
      const height = Math.abs(currentY - startY) / dpr;

      if (width > 0 && height > 0) {
        // 绘制选择框边框
        ctx.strokeStyle = "#00ff00";
        ctx.lineWidth = 2;
        ctx.setLineDash([5, 5]);
        ctx.strokeRect(x, y, width, height);

        // 先清除已有的DOM按钮
        this.removeCropButtons();

        // 创建DOM按钮
        this.createCropButtons(canvas, x, y, width, height);
      } else {
        // 如果选择框无效，移除按钮
        this.removeCropButtons();
      }
    },

    // 创建裁剪按钮DOM元素
    createCropButtons(canvas, x, y, width, height) {
      // 获取Canvas在页面中的位置
      const canvasRect = canvas.getBoundingClientRect();

      // 计算按钮在页面中的位置
      // 按钮放在选择框的右下角外面
      const buttonContainer = document.createElement("div");
      buttonContainer.className = "crop-buttons-container";
      buttonContainer.style.position = "absolute";
      buttonContainer.style.zIndex = "1000";
      buttonContainer.style.width = "80px";
      buttonContainer.style.display = "flex";
      buttonContainer.style.gap = "10px";

      // 计算按钮位置（相对于页面）
      const left = canvasRect.left + x + width - 80;
      const top = canvasRect.top + y + height + 10;

      buttonContainer.style.left = left + "px";
      buttonContainer.style.top = top + "px";

      // 创建确认按钮
      const confirmBtn = document.createElement("button");
      confirmBtn.className = "crop-confirm-btn";
      confirmBtn.textContent = "确认";
      confirmBtn.style.padding = "3px 8px";
      confirmBtn.style.background = "#1890ff";
      confirmBtn.style.color = "white";
      confirmBtn.style.border = "none";
      confirmBtn.style.borderRadius = "4px";
      confirmBtn.style.cursor = "pointer";
      confirmBtn.style.fontSize = "8px";

      // 创建取消按钮
      const cancelBtn = document.createElement("button");
      cancelBtn.className = "crop-cancel-btn";
      cancelBtn.textContent = "取消";
      cancelBtn.style.padding = "3px 8px";
      cancelBtn.style.background = "#f5222d";
      cancelBtn.style.color = "white";
      cancelBtn.style.border = "none";
      cancelBtn.style.borderRadius = "4px";
      cancelBtn.style.cursor = "pointer";
      cancelBtn.style.fontSize = "8px";

      // 添加按钮事件监听
      confirmBtn.addEventListener("click", async () => {
        console.log("确认按钮被点击");
        await this.cropPDF();
        this.removeCropButtons();
      });

      cancelBtn.addEventListener("click", () => {
        console.log("取消按钮被点击");
        this.exitCropMode();
        this.removeCropButtons();
      });

      // 鼠标悬停效果
      confirmBtn.addEventListener("mouseenter", () => {
        confirmBtn.style.background = "#40a9ff";
      });
      confirmBtn.addEventListener("mouseleave", () => {
        confirmBtn.style.background = "#1890ff";
      });

      cancelBtn.addEventListener("mouseenter", () => {
        cancelBtn.style.background = "#ff4d4f";
      });
      cancelBtn.addEventListener("mouseleave", () => {
        cancelBtn.style.background = "#f5222d";
      });

      // 添加到容器
      buttonContainer.appendChild(confirmBtn);
      buttonContainer.appendChild(cancelBtn);

      // 添加到页面
      document.body.appendChild(buttonContainer);

      // 保存按钮引用以便后续移除
      this.cropButtonsContainer = buttonContainer;

      console.log("裁剪按钮已创建", { left, top });
    },

    // 移除裁剪按钮
    removeCropButtons() {
      if (this.cropButtonsContainer && this.cropButtonsContainer.parentNode) {
        this.cropButtonsContainer.parentNode.removeChild(
          this.cropButtonsContainer
        );
        this.cropButtonsContainer = null;
        console.log("裁剪按钮已移除");
      }
    },

    exitCropMode() {
      if (!this.isCropMode) return;

      // 移除事件监听
      this.removeCropEvents();

      // 重置裁剪状态
      this.isCropMode = false;
      this.cropArea.isSelecting = false;

      // 恢复原始图像（如果有）
      if (
        this.cropArea.originalData &&
        this.cropArea.canvas &&
        this.cropArea.ctx
      ) {
        const { ctx, originalData } = this.cropArea;
        ctx.putImageData(originalData, 0, 0);
      }

      // 重置cropArea
      this.cropArea = {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        isSelecting: false,
        originalData: null,
        canvas: null,
        ctx: null,
      };

      console.log("已退出裁剪模式");
    },

    removeCropEvents() {
      const canvas = this.cropArea.canvas;
      if (!canvas) return;
      canvas.removeEventListener("mousedown", this.handleCropMouseDown);
      canvas.removeEventListener("mousemove", this.handleCropMouseMove);
      canvas.removeEventListener("mouseup", this.handleCropMouseUp);
    },

    async cropPDF() {
      try {
        console.log("🚀 开始裁剪PDF处理...");

        // 第一步：验证选择框是否有效
        const dpr = window.devicePixelRatio || 1;
        const cssWidth =
          Math.abs(this.cropArea.currentX - this.cropArea.startX) / dpr;
        const cssHeight =
          Math.abs(this.cropArea.currentY - this.cropArea.startY) / dpr;
        console.log("📏 选择框验证:", {
          startX: this.cropArea.startX,
          startY: this.cropArea.startY,
          currentX: this.cropArea.currentX,
          currentY: this.cropArea.currentY,
          cssWidth,
          cssHeight,
          dpr,
        });

        // 如果选择框太小，直接返回
        if (cssWidth < 10 || cssHeight < 10) {
          console.error("❌ 选择框太小，无法裁剪");
          this.$message.warning(
            "请拖动鼠标选择更大的裁剪区域（至少10x10像素）"
          );
          return;
        }

        // 第二步：获取页面信息
        const pageIndex = this.pdfShowNum;
        const pageObj = this.canvasContainer[pageIndex].page;

        // 获取Canvas信息
        const canvas = this.cropArea.canvas;
        if (!canvas) {
          console.error("❌ Canvas未找到");
          this.$message.error("Canvas未找到");
          return;
        }

        // 获取页面原始尺寸
        const viewport = pageObj.getViewport({ scale: 1 });
        const pageWidth = viewport.width;
        const pageHeight = viewport.height;

        // 计算当前Canvas的缩放比例
        const canvasStyleWidth =
          parseFloat(canvas.style.width) || canvas.clientWidth;
        const scale = canvasStyleWidth / pageWidth;
        this.currentScale = scale;

        // 计算Canvas实际显示尺寸和偏移（考虑PDF在Canvas中可能居中显示）
        const canvasStyleHeight =
          parseFloat(canvas.style.height) || canvas.clientHeight;
        const displayedWidth = pageWidth * scale;
        const displayedHeight = pageHeight * scale;
        const offsetX = (canvasStyleWidth - displayedWidth) / 2;
        const offsetY = (canvasStyleHeight - displayedHeight) / 2;

        console.log("📐 尺寸信息:", {
          pageWidth,
          pageHeight,
          canvasStyleWidth,
          canvasStyleHeight,
          scale,
          dpr,
          displayedWidth,
          displayedHeight,
          offsetX,
          offsetY,
        });

        // 计算选择框在Canvas CSS像素中的坐标
        const cssX =
          Math.min(this.cropArea.startX, this.cropArea.currentX) / dpr;
        const cssY =
          Math.min(this.cropArea.startY, this.cropArea.currentY) / dpr;
        const cssWidthFinal =
          Math.abs(this.cropArea.currentX - this.cropArea.startX) / dpr;
        const cssHeightFinal =
          Math.abs(this.cropArea.currentY - this.cropArea.startY) / dpr;

        console.log("🔄 CSS坐标转换:", {
          cssX,
          cssY,
          cssWidth: cssWidthFinal,
          cssHeight: cssHeightFinal,
        });

        // 将Canvas坐标转换为PDF页面坐标（关键修正部分）
        // 考虑Canvas可能不是完全填满的，需要减去偏移量
        const pdfX = (cssX - offsetX) / scale;

        // PDF的Y轴原点在左下角，Canvas在左上角，需要转换
        // 公式：pdfY = pageHeight - ((cssY - offsetY) / scale + cssHeightFinal / scale)
        const pdfY = pageHeight - (cssY - offsetY) / scale;

        const pdfWidth = cssWidthFinal / scale;
        const pdfHeight = cssHeightFinal / scale;

        // 计算裁剪框的四个角坐标
        const llx = pdfX;
        const lly = pdfY - pdfHeight; // 左下角Y需要减去高度
        const urx = pdfX + pdfWidth;
        const ury = pdfY; // 右上角Y

        console.log("🎯 PDF裁剪坐标:", { llx, lly, urx, ury });
        console.log("📏 PDF裁剪尺寸:", { width: pdfWidth, height: pdfHeight });
        console.log("📐 PDF页面尺寸:", { pageWidth, pageHeight });

        // 第三步：使用pdf-lib进行裁剪
        console.log("✂️ 开始PDF裁剪操作...");

        const originalPdfBytes = this.originalInfo;
        const pdfDoc = await PDFDocument.load(originalPdfBytes);
        const pages = pdfDoc.getPages();
        const page = pages[pageIndex];

        // 验证坐标是否在页面范围内
        if (llx < 0 || lly < 0 || urx > pageWidth || ury > pageHeight) {
          console.warn("⚠️ 裁剪区域超出页面范围，自动调整到边界内");

          // 自动调整到页面边界内
          const adjustedLlX = Math.max(0, Math.min(llx, pageWidth - 1));
          const adjustedLlY = Math.max(0, Math.min(lly, pageHeight - 1));
          const adjustedUrX = Math.max(1, Math.min(urx, pageWidth));
          const adjustedUrY = Math.max(1, Math.min(ury, pageHeight));

          console.log("🔄 调整后的裁剪坐标:", {
            llx: adjustedLlX,
            lly: adjustedLlY,
            urx: adjustedUrX,
            ury: adjustedUrY,
          });

          // 使用调整后的坐标设置裁剪框
          page.setCropBox(
            adjustedLlX,
            adjustedLlY,
            adjustedUrX - adjustedLlX,
            adjustedUrY - adjustedLlY
          );
        } else {
          // 设置裁剪框
          page.setCropBox(llx, lly, urx - llx, ury - lly);
        }

        const croppedPdfBytes = await pdfDoc.save();

        console.log("✅ PDF裁剪完成，开始更新预览...");

        // 第四步：更新预览
        const newPdfBlob = new Blob([croppedPdfBytes], {
          type: "application/pdf",
        });
        const newFile = new File([newPdfBlob], "cropped.pdf", {
          type: "application/pdf",
          lastModified: Date.now(),
        });

        const pdfInfo = new PDFController();
        this.pdfDocument = await pdfInfo.readFile(newFile);
        const pageNums = await this.pdfDocument.numPages;

        this.canvasContainer = [];
        const oldPageIndex = this.pdfShowNum;

        for (let num = 1; num <= pageNums; num++) {
          try {
            const page = await this.pdfDocument.getPage(num);
            this.canvasContainer.push({
              page,
              rotate: 0,
            });
          } catch (error) {
            console.error(`加载第${num}页失败:`, error);
          }
        }

        if (oldPageIndex >= this.canvasContainer.length) {
          this.pdfShowNum = Math.max(0, this.canvasContainer.length - 1);
        }

        this.originalInfo = croppedPdfBytes;
        await this.$nextTick();
        await this.renderAllPages();

        this.$message.success("PDF裁剪成功！");
      } catch (error) {
        console.error("❌ 裁剪PDF失败:", error);
        this.$message.error("裁剪失败: " + error.message);
      } finally {
        this.exitCropMode();
      }
    },

    async ratePage() {
      // 获取当前页面的旋转角度
      let currentRotation = this.canvasContainer[this.pdfShowNum].rotate;

      // 增加90度，并取模360
      currentRotation = (currentRotation + 90) % 360;

      // 更新旋转角度
      this.canvasContainer[this.pdfShowNum].rotate = currentRotation;

      const container = document.querySelector(".pdf_pages_wrapper");
      if (!container) return;

      const containerWidth = container.clientWidth;
      // 传递旋转角度
      await this.renderPage(this.pdfShowNum, containerWidth, {
        currentRotation: currentRotation,
      });
    },

    async save() {
      try {
        // 1. 检查原始数据
        const originalBytes = this.originalInfo;
        if (!originalBytes) {
          this.$message.warning("没有可保存的PDF数据");
          return;
        }

        // 2. 加载PDF文档以进行修改
        const pdfDoc = await PDFDocument.load(originalBytes);
        const pages = pdfDoc.getPages();

        // 3. 将前端旋转状态同步到PDF每一页
        const pageCount = Math.min(pages.length, this.canvasContainer.length);

        console.log("开始同步旋转状态，共", pageCount, "页");

        for (let i = 0; i < pageCount; i++) {
          const page = pages[i];
          let rotation = this.canvasContainer[i].rotate;

          // 调试信息
          console.log(
            `页面 ${i + 1} 原始旋转值:`,
            rotation,
            "类型:",
            typeof rotation
          );

          // 确保旋转角度有效
          if (rotation === undefined || rotation === null) {
            rotation = 0;
          }

          // 转换为数字
          rotation = Number(rotation);
          if (isNaN(rotation)) {
            rotation = 0;
          }

          // 规范化旋转角度到 0, 90, 180, 270
          rotation = rotation % 360;
          if (rotation < 0) rotation += 360;

          // 四舍五入到最近的90度倍数
          rotation = Math.round(rotation / 90) * 90;
          if (rotation === 360) rotation = 0;

          console.log(`页面 ${i + 1} 设置旋转角度:`, rotation);

          page.setRotation(degrees(rotation));
        }

        // 4. 保存修改后的PDF字节
        const modifiedPdfBytes = await pdfDoc.save();

        // 5. 触发下载
        const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = this.name;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 6. 清理并提示
        setTimeout(() => URL.revokeObjectURL(downloadUrl), 100);
        this.$message.success("PDF保存成功！（已包含页面旋转）");
      } catch (error) {
        console.error("保存PDF失败:", error);
        this.$message.error("保存失败: " + error.message);
      }
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);

    document.addEventListener("click", this.handleGlobalClick);

    // 页面初始化
    this.initializePage();

    this.createMenu();
  },

  beforeDestroy() {
    // 组件销毁时移除事件监听
    window.removeEventListener("resize", this.handleResize);

    document.removeEventListener("click", this.handleGlobalClick);

    // 清理定时器
    clearTimeout(this.resizeTimer);

    // 清理PDF文档
    if (this.pdfDocument) {
      if (this.pdfDocument.destroy) {
        this.pdfDocument.destroy();
      }
      this.pdfDocument = null;
    }

    // 清理loading实例
    if (this.loadingInstance) {
      this.loadingInstance.close();
    }
  },
};
</script>

<style scoped lang="scss">
@import "src/common/style/index";

.pdf_document {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: $main_theme_color;
    box-sizing: border-box;
    align-items: center;
    color: #ffffff;
    height: 60px;
    flex-shrink: 0;

    .icon_list {
      display: flex;
      flex-direction: row;
      align-items: center;

      .icon,
      .menu {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        color: $main_theme_color;
        overflow: hidden;
        border-radius: 20%;
        width: 24px;
        height: 24px;
        padding: 4px;

        .el-image {
          width: 100%;
          height: 100%;
        }
      }

      .menu {
        margin: 0 10px;

        .el-dropdown {
          .el-dropdown-link {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            .el-image {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .el-divider {
        margin-right: 10px;
      }

      .bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 20px;
        font-size: 0.8rem;
        flex: 1;
        margin-left: 20px;

        .bar_active {
          background-color: #ffffff;
          color: $main_theme_color;
          border-radius: 15px;
          padding: 4px 10px;
        }
      }
    }
  }

  // 初始加载样式
  .loading-overlay {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .loading-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      .loading-icon {
        font-size: 40px;
        color: $main_theme_color;
        animation: rotating 2s linear infinite;
      }

      .loading-text {
        font-size: 16px;
        color: $main_font_color;
      }
    }
  }

  .empty {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .el-image {
      margin: 0;
    }

    & > span {
      font-size: 12px;
      color: $help_font_color;
    }
  }

  .pdf_container {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    display: inline-flex;
    background-color: #dddedf;

    & > div:first-child {
      width: 32%;
      height: 100%;
    }

    & > div:nth-child(2) {
      width: 36%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      padding: 20px 0;

      .pdf_page_item {
        width: 100%;
        display: flex;
        justify-content: center;

        .pdf_canvas {
          display: block;
          width: 100%;
          height: auto;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
      }
    }

    & > div:last-child {
      width: 32%;
      height: 100%;
    }
  }
}

// 旋转动画
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
